import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
  { icon: '🔐', title: 'Secure Asset Vault', desc: 'Highly secured vault for storing recovered digital assets with multi‑layer encryption.' },
  { icon: '📊', title: 'Asset Monitoring', desc: 'Real‑time monitoring of asset balances, market movements, and transaction alerts.' },
  { icon: '🆔', title: 'Verification Center', desc: 'KYC, ownership and document verification to confirm the rightful owner of every asset.' },
  { icon: '✅', title: 'Release Management', desc: 'Multi‑level approval process ensuring no asset leaves without rigorous checks.' },
  { icon: '📋', title: 'Transaction Audit', desc: 'Complete, immutable audit trail of all vault transactions and activities.' },
  { icon: '🛡️', title: 'Security Operations', desc: '24/7 threat monitoring and detection systems operated by security experts.' },
  { icon: '📜', title: 'Asset Certificates', desc: 'Generate proof‑of‑custody and ownership certificates for full transparency.' },
  { icon: '⚖️', title: 'Compliance Support', desc: 'Assistance with legal, regulatory and reporting requirements worldwide.' },
  { icon: '🎧', title: 'Customer Support', desc: 'Dedicated support team available 24/7 for all vault users via chat and email.' },
];

function Services() {
  return (
    <div className="services-page">

      {/* ── Back to Home arrow ── */}
      <Link
        to="/"
        style={{
          position: 'fixed',
          top: '1.25rem',
          left: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '0.9rem',
          fontWeight: 500,
          zIndex: 100,
          transition: 'color 0.2s',
          textDecoration: 'none',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
      >
        ← Home
      </Link>

      <div className="services-hero">
        <h1>Our Services</h1>
        <p>Everything you need to securely store, monitor, and release recovered digital assets.</p>
      </div>

      <div className="services-grid">
        {services.map((svc, idx) => (
          <div key={idx} className="service-card-detailed">
            <div className="service-icon-large">{svc.icon}</div>
            <h3>{svc.title}</h3>
            <p>{svc.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;